module.exports = __webpack_public_path__ + "static/media/midcityimg.410b0f09.webp";